/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Iframe_Remote_Style_Guide_Failed_ToastInputs */

const en_iframe_remote_style_guide_failed_toast = /** @type {(inputs: Iframe_Remote_Style_Guide_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to load style guide: ${i?.error}`)
};

const fr_iframe_remote_style_guide_failed_toast = /** @type {(inputs: Iframe_Remote_Style_Guide_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec du chargement du guide de style : ${i?.error}`)
};

const de_iframe_remote_style_guide_failed_toast = /** @type {(inputs: Iframe_Remote_Style_Guide_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Styleguide konnte nicht geladen werden: ${i?.error}`)
};

const it_iframe_remote_style_guide_failed_toast = /** @type {(inputs: Iframe_Remote_Style_Guide_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile caricare la guida di stile: ${i?.error}`)
};

const ru_iframe_remote_style_guide_failed_toast = /** @type {(inputs: Iframe_Remote_Style_Guide_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось загрузить руководство по стилю: ${i?.error}`)
};

const es_iframe_remote_style_guide_failed_toast = /** @type {(inputs: Iframe_Remote_Style_Guide_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al cargar la guía de estilo: ${i?.error}`)
};

const zh_cn2_iframe_remote_style_guide_failed_toast = /** @type {(inputs: Iframe_Remote_Style_Guide_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`加载样式指南失败：${i?.error}`)
};

const ja_iframe_remote_style_guide_failed_toast = /** @type {(inputs: Iframe_Remote_Style_Guide_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`スタイルガイドの読み込みに失敗しました: ${i?.error}`)
};

const hi_iframe_remote_style_guide_failed_toast = /** @type {(inputs: Iframe_Remote_Style_Guide_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`स्टाइल गाइड लोड करने में विफल: ${i?.error}`)
};

const pt_pt2_iframe_remote_style_guide_failed_toast = /** @type {(inputs: Iframe_Remote_Style_Guide_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao carregar o guia de estilo: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to load style guide: {error}" |
*
* @param {Iframe_Remote_Style_Guide_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_style_guide_failed_toast = /** @type {((inputs: Iframe_Remote_Style_Guide_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Style_Guide_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_style_guide_failed_toast(inputs)
	if (locale === "de") return de_iframe_remote_style_guide_failed_toast(inputs)
	if (locale === "it") return it_iframe_remote_style_guide_failed_toast(inputs)
	if (locale === "ru") return ru_iframe_remote_style_guide_failed_toast(inputs)
	if (locale === "es") return es_iframe_remote_style_guide_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_style_guide_failed_toast(inputs)
	if (locale === "ja") return ja_iframe_remote_style_guide_failed_toast(inputs)
	if (locale === "hi") return hi_iframe_remote_style_guide_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_style_guide_failed_toast(inputs)
	return en_iframe_remote_style_guide_failed_toast(inputs)
});